import { render, staticRenderFns } from "./memberCollectionPol.vue?vue&type=template&id=d24fafaa&scoped=true"
import script from "./memberCollectionPol.vue?vue&type=script&lang=js"
export * from "./memberCollectionPol.vue?vue&type=script&lang=js"
import style0 from "./memberCollectionPol.vue?vue&type=style&index=0&id=d24fafaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24fafaa",
  null
  
)

export default component.exports